import React, {useState} from 'react'

export default function TextForm(props) {
    const handleUpClick =()=>{
        let newText= text.toUpperCase();
        setText(newText)
        props.showAlert("Converted to uppercase!","success");
    }

    const handleLoClick =()=>{
        let newText= text.toLocaleLowerCase();
        setText(newText)
        props.showAlert("Converted to lowercase!","success");
    }

    const handleClClick =()=>{
        let newText= '';
        setText(newText)
        props.showAlert("Cleared!","success");
    }

    const handleCopy =()=>{
        let mytext = document.getElementById("mybox");
        mytext.select();
        navigator.clipboard.writeText(mytext.value);
        props.showAlert("Text copied!","success");
    }
    const handleExtraSpace=()=>{
        let newText=text.split(/[ ]+/);
        setText(newText.join(" "))
        props.showAlert("Extra Space Removed!","success");

    }
    const handleOnChange =(event)=>{
        setText(event.target.value)
    }

    const [text, setText] = useState('');
    // text="New Text"; //Wong way to set the text
    // setText("New Text"); //Correct way to set the text
  return (
    <>
    <div className="container" style={{color: props.mode==='dark'?'white':'black'}}>
        <h1>{props.heading}</h1>
        <div className="mb-3">
        <textarea className="form-control shadow p-3 mb-5 rounded" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'grey':'white',color:props.mode==='dark'?'white':'black'}} id="mybox" rows="8"></textarea>
        </div> 
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-2 my-1shadow p-3 mb-5 rounded"  onClick={handleUpClick}>Convert to UpperCase</button> 
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-2 my-1shadow p-3 mb-5 rounded" onClick={handleLoClick}>Convert to LowerCase</button>
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-2 my-1shadow p-3 mb-5 rounded" onClick={handleExtraSpace}>Remove Extra Spaces</button>
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-2 my-1shadow p-3 mb-5 rounded" onClick={handleCopy}>Copy</button>
        <button disabled={text.length===0} type="button" className="btn btn-primary mx-2 my-1shadow p-3 mb-5 rounded" onClick={handleClClick}>Clear</button>
        
    </div>
    <div className="container my-3" style={{color: props.mode==='dark'?'white':'black'}}>
        <h2><strong>Your Text Summary</strong></h2>
        <p><strong>Number of Words -</strong>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} </p>
        <p><strong>NUmber of Characters -</strong> {text.length} </p>
        <p><strong>Number of Sentences -</strong> {text.split(".").length}</p>
        <p><strong>Average Read Time -</strong> {0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} </p>
        <h2><strong>Preview</strong></h2>
        <p>{text.length>0?text:"Nothing to preview"}</p>
    </div>
    </>
  )
}
